/** A refusal that means the user still has to fill something in, not a crash. */
export function noticeForMissingData(error: unknown): string | null {
  const text = typeof error === 'string' ? error : '';
  if (!text) return null;
  if (text.includes('Recurrence settings did not produce any dates')) {
    return 'אין חזרה בטווח שנבחר. עדכנו את תאריך ההתחלה או הסיום.';
  }
  if (text.includes('Missing receipt_date')) {
    return 'חסר תאריך חשבונית לחזרה. מלאו את התאריך.';
  }
  if (text.includes('Invalid receipt_date')) {
    return 'תאריך החשבונית אינו תקין. מלאו תאריך.';
  }
  if (text.includes('Missing field') || text.includes('Choose a category')) {
    return 'חסרים פרטים. מלאו את השדות החסרים ושמרו שוב.';
  }
  return null;
}
